import { FooterContainer } from "../../style/main/main";

const MainFooter = () => {
  return (
    <FooterContainer>
      <div className="logo">
        <span className="icon-box">
          <img src="../assets/gray_logo.png" alt="" />
        </span>
        <span className="img-box">
          <img src="../assets/gray_logo_txt.png" alt="" />
        </span>
      </div>
      <h3>Copyright © SpeedBackup All Rights Reserved.</h3>
    </FooterContainer>
  );
};

export default MainFooter;
